// useTents.js
import {onMounted, ref} from 'vue';
import api from "@/api/api";

const tentPlacements = ref([]);
const tentPlacementsLoading = ref(false);
const tentPlacementsLoaded = ref(false);

const fetchTentPlacements = async () => {
    if(tentPlacementsLoaded.value) {
        return;
    }
    tentPlacementsLoading.value = true;
    try {
        // Get current language from window or default to 'nl'
        const lang = window.rbs_vr_object?.lang || 'nl';
        const response = await api.get(`/tent_placements/?lang=${lang}`);
        tentPlacements.value = response.data;
        tentPlacementsLoaded.value = true;
    } catch (error) {
        console.error('Error fetching tentPlacements:', error);
    } finally {
        tentPlacementsLoading.value = false;
    }
};

const tentPlacementsToOptions = () => {
    let result = {};

    tentPlacements.value.forEach(curr => {
        result[curr.id] = { text: `${curr.placement_description}` };
    });

    return result;
};

export default function useTentPlacements() {
    onMounted(fetchTentPlacements);
    return { tentPlacements, fetchTentPlacements, tentPlacementsToOptions, tentPlacementsLoading, tentPlacementsLoaded };
}
